// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zvDK","type":"styles_type__BN4Tl","choices":"styles_choices__3NJoe"};